//import Scss
import './assets/scss/themes.scss';
import { GoogleOAuthProvider } from '@react-oauth/google';
//imoprt Route
import Route from './Routes';
import config from "config";
import 'amazon-connect-streams';
import { CCPProvider } from './CCPContext/CCPContext';

const { google } = config;
const CLIENT_ID = google.CLIENT_ID

function App() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <CCPProvider>
        <Route />
      </CCPProvider>
    </GoogleOAuthProvider>

  );
}

export default App;
